import { Form, Input } from 'antd';
import { get } from 'lodash';
import { Controller } from 'react-hook-form';

function TextField({
    control, label, placeholder, fieldName, errors, showCount, maxLength,
}) {
    return (
        <Form.Item
            label={label}
            validateStatus={get(errors, fieldName) ? 'error' : ''}
            help={get(errors, fieldName)?.message}
        >
            <Controller
                control={control}
                name={fieldName}
                render={({ field }) => (
                    <Input.TextArea
                        {...field}
                        placeholder={placeholder}
                        showCount={showCount}
                        maxLength={maxLength}
                    />
                )}
            />
        </Form.Item>
    );
}

export default TextField;
